export default "__VITE_ASSET__9sNZtJ24__";